import axios from "axios";

export function findByEmail(email) {
  return axios.get(`/api/externalUsers?email=${email}`).then(response => response.data.value);
}
